import { render, staticRenderFns } from "./DepositAddresses.vue?vue&type=template&id=cbb4e05c&scoped=true&"
import script from "./DepositAddresses.vue?vue&type=script&lang=js&"
export * from "./DepositAddresses.vue?vue&type=script&lang=js&"
import style0 from "./DepositAddresses.vue?vue&type=style&index=0&id=cbb4e05c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbb4e05c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VSnackbar})
